(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["order-count"] && !window.DesignMode) return;
  try {
    
const totalOrderElement = document.getElementById('total_order');

// Set the initial total orders value
let totalOrders = 510742;
totalOrderElement.textContent = formatTotalOrders(totalOrders);

// Function to increment the total orders by 35 each day
function incrementTotalOrders() {
  totalOrders += 35;
  totalOrderElement.textContent = formatTotalOrders(totalOrders);
}

// Call the incrementTotalOrders() function initially
  
incrementTotalOrders();

// Schedule the incrementTotalOrders() function to run every day (in milliseconds)
const interval = 24 * 60 * 60 * 1000; // 24 hours
setInterval(incrementTotalOrders, interval);

// Function to format the total orders with comma separator
function formatTotalOrders(number) {
  return number.toLocaleString();
}


  } catch(e) { console.error(e); }
})();
})();
